import { NodeProps } from '@xyflow/react';
import { memo, useCallback } from 'react';
import AutoResizeTextarea from '../node.label';

import { lightenBy } from '../../../../../shared/utils/color.utils';
import { NodeModel, SwimlaneNodeModel } from '@diagram/model/node.model';
import { useDiagramStore } from '@diagram/ui/hooks/diagram-store.hook';
import { NodeResizeControl } from '../node.resizer';
import {
  ArrowLeftCircleIcon,
  ArrowUpCircleIcon,
} from '@heroicons/react/20/solid';
import {
  ArrowDownCircleIcon,
  ArrowRightCircleIcon,
} from '@heroicons/react/16/solid';

const Swimlane: React.FC<NodeProps<NodeModel>> = memo(
  ({ data, selected, id, width, height }: NodeProps<NodeModel>) => {
    const { color, orientation, label } = data as SwimlaneNodeModel['data'];
    // const { fitView } = useReactFlow();
    const borderColor = selected ? color : lightenBy(color, 30);
    // const selectNode = useDiagramStore((s) => s.selectNode);
    const updateNodeLabel = useDiagramStore((s) => s.updateNodeLabel);
    const insertLaneAt = useDiagramStore((s) => s.swimlane.insertLaneAt);

    // const handleLabelClick = useCallback(
    //   (e: React.MouseEvent) => {
    //     e.stopPropagation();
    //     if (parentId) {
    //       selectNode(parentId);
    //       fitView({
    //         padding: 0.2,
    //         duration: 500,
    //         nodes: [{ id: parentId }],
    //       });
    //     }
    //   },
    //   [parentId, selectNode, fitView]
    // );

    const handleInput = (val: string) => {
      updateNodeLabel(id, val);
    };

    const horizontal = orientation === 'horizontal';

    const divClasses = horizontal
      ? 'absolute top-0 h-full w-full max-w-15 flex flex-col items-center justify-center border-r-2'
      : 'absolute left-0 h-14 w-full flex flex-row items-center justify-center border-b-2';

    const handleClick = useCallback(
      (idx: number) => {
        insertLaneAt(id, idx);
      },
      [id, insertLaneAt]
    );

    const buttons = [
      {
        top: orientation === 'horizontal' ? '15px' : '50%',
        left: orientation === 'horizontal' ? '50%' : '0',
        transform:
          orientation === 'horizontal'
            ? 'translate(-50%, -50%)'
            : 'translate(50%, -50%)',
        Icon:
          orientation === 'horizontal'
            ? ArrowUpCircleIcon
            : ArrowLeftCircleIcon,
      },
      {
        bottom: orientation === 'horizontal' ? '15px' : '50%',
        left: orientation === 'horizontal' ? '50%' : '0',
        transform:
          orientation === 'horizontal'
            ? 'translate(-50%, 50%)'
            : 'translate(50%, -50%)',
        Icon:
          orientation === 'horizontal'
            ? ArrowDownCircleIcon
            : ArrowRightCircleIcon,
      },
    ];

    return (
      <>
        <div
          className="relative"
          style={{
            width,
            height,
            borderColor: !selected ? color : 'transparent',
            borderWidth: 2,
          }}
        >
          <NodeResizeControl nodeId={id} type="swimlane" show={selected} />
          {buttons.map((btn, index) => (
            <button
              key={`${id}-btn-${index}`}
              className="absolute duration-300 transition-all ease-in-out"
              onClick={() => handleClick(index)}
              style={{
                display: selected ? 'block' : 'none',
                top: btn.top,
                bottom: btn.bottom,
                left: btn.left,
                transform: btn.transform,
              }}
            >
              <btn.Icon className="size-6 duration-300 transition-all ease-in-out text-primary stroke-white hover:text-accent" />
            </button>
          ))}

          <div
            className={divClasses}
            style={{ backgroundColor: lightenBy(color, 90), borderColor }}
          >
            <AutoResizeTextarea
              className={horizontal ? 'rotate-270 whitespace-nowrap' : ''}
              value={label}
              onChange={handleInput}
            />
          </div>
        </div>
      </>
    );
  }
);

Swimlane.displayName = 'Swimlane';

export default Swimlane;
